import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

export interface GetResolution886CategoryResultParams {
	assessment_id: string;
	organization_id: string;
	company_id: string;
	category_key: string;
	review_id: string;
}

const Service = Resolution886ReportService.getInstance();

export const useGetResolution886CategoryResult = (params: GetResolution886CategoryResultParams) => {
	const isEnabled = validateUuid([params.organization_id, params.company_id, params.assessment_id, params.review_id]);

	return useQuery({
		queryKey: [QUERY_KEYS.GET_RESOLUTION_886_CATEGORY, params],
		queryFn: async () => Service.getCategoryResult({ ...params, category_key: params.category_key }),
		enabled: isEnabled && !!params.category_key,
		retry: false
	});
};
